<template>
  <section class="container d-flex flex-column mt-5">
    <h3 class="text-center">O que é?</h3>

    <p class="text-justify">
      <strong>Tornverse</strong> é um multiverso que agrega histórias e
      personagens criadas por
      <a href="https://wendelladriel.com" target="_blank">Wendell Adriel</a> ao
      longo dos anos.
    </p>

    <p class="text-justify">
      As histórias se passam em diversos universos que podem ou não ter conexão
      uns com os outros e podem se passar em diversos períodos diferentes. Há
      histórias que se passam na <strong>Era Medieval</strong>, outras histórias
      se passam no <strong>Tempo Moderno</strong>, outras se passam no
      <strong>Futuro</strong>
      e algumas possuem uma mistura de elementos de diversos períodos.
    </p>

    <p class="text-justify">
      Muitos universos, histórias e personagens já estão criados e/ou em fase de
      criação, mas irei liberar aos poucos, então sempre que quiser dê uma
      olhada se há algo novo pelo site!
    </p>

    <p class="text-justify">
      O multiverso foi criado por uma divindade conhecida como
      <strong>WALS</strong>. Essa divindade é
      <strong>Onipotente, Onisciente e Onipresente</strong> no
      <strong>Tornverse</strong>.
    </p>

    <p class="text-center">
      <small
        >Alguns personagens foram baseados ou tiveram influência de outras
        histórias</small
      >
    </p>

    <h3 class="my-3 text-center">Universos</h3>

    <p v-for="universe in universes" :key="universe.slug" class="text-center">
      <router-link :to="`/${universe.slug}`">{{ universe.name }}</router-link>
    </p>

    <h3 class="my-3 text-center">Torn Arena</h3>

    <p class="text-justify">
      A <strong>Torn Arena</strong> é uma competição realizada por
      <strong>WALS</strong> periodicamente, apenas para seu entretenimento, onde
      ele escolhe seres de diversos universos para combater em um torneio de
      luta. Abaixo você pode conferir todas edições da
      <strong>Torn Arena</strong> até hoje.
    </p>

    <p
      v-for="tournament in tournaments"
      :key="tournament.url"
      class="text-center"
    >
      <a :href="tournament.url" target="_blank">{{ tournament.name }}</a>
    </p>
  </section>
</template>

<script>
export default {
  name: 'home',

  inject: ['universes', 'tournaments'],
}
</script>
